"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.map.js");
var _routeParser = _interopRequireDefault(require("./route-parser.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(items) {
  var matchers = (items || []).map(function (item) {
    return {
      item: item,
      isMatch: (0, _routeParser["default"])(item.pattern)
    };
  });
  return function (pathname) {
    for (var i = 0; i < matchers.length; i++) {
      var params = matchers[i].isMatch(pathname);
      if (params) {
        return {
          item: matchers[i].item,
          params: params
        };
      }
    }
  };
};
//# sourceMappingURL=route-matcher.js.map